var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import * as React from 'react';

function SvgRepeat(props) {
  return React.createElement("svg", __assign({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), React.createElement("g", {
    clipPath: "url(#repeat_svg__clip0)",
    fill: "#000"
  }, React.createElement("path", {
    d: "M16.293 8.293a1 1 0 001.414 1.414l4-4a1 1 0 000-1.414l-4-4a1 1 0 10-1.414 1.414L19.586 5l-3.293 3.293z"
  }), React.createElement("path", {
    d: "M4 11V9a3 3 0 013-3h14a1 1 0 100-2H7a5 5 0 00-5 5v2a1 1 0 102 0zM7.707 15.707a1 1 0 10-1.414-1.414l-4 4a1 1 0 000 1.414l4 4a1 1 0 001.414-1.414L4.414 19l3.293-3.293z"
  }), React.createElement("path", {
    d: "M20 13v2a3 3 0 01-3 3H3a1 1 0 100 2h14a5 5 0 005-5v-2a1 1 0 10-2 0zM16.293 8.293a1 1 0 001.414 1.414l4-4a1 1 0 000-1.414l-4-4a1 1 0 10-1.414 1.414L19.586 5l-3.293 3.293z"
  }), React.createElement("path", {
    d: "M4 11V9a3 3 0 013-3h14a1 1 0 100-2H7a5 5 0 00-5 5v2a1 1 0 102 0zM7.707 15.707a1 1 0 10-1.414-1.414l-4 4a1 1 0 000 1.414l4 4a1 1 0 001.414-1.414L4.414 19l3.293-3.293z"
  }), React.createElement("path", {
    d: "M20 13v2a3 3 0 01-3 3H3a1 1 0 100 2h14a5 5 0 005-5v-2a1 1 0 10-2 0z"
  })), React.createElement("defs", null, React.createElement("clipPath", {
    id: "repeat_svg__clip0"
  }, React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  }))));
}

export default SvgRepeat;